// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f0b19c1be59e4c61b269","113":"7c36a4db6fcf8fa7f977","114":"67d4d004cf099c9aac59","162":"65a124b7d953965296bf"}[chunkId] + ".chunk.js";
};